export const SYSTEM_SENDER_ID = 'hubspot';